import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
export { useState, useEffect, useMemo, useRef, useCallback };

/* ─── Icons ──────────────────────────────────────────────────── */
export const I = {
  Back: (p) => <svg viewBox="0 0 24 24" width={p.size||20} height={p.size||20} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>,
  Right: (p) => <svg viewBox="0 0 24 24" width={p.size||20} height={p.size||20} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6"/></svg>,
  Logout: (p) => <svg viewBox="0 0 24 24" width={p.size||18} height={p.size||18} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>,
  Search: (p) => <svg viewBox="0 0 24 24" width={p.size||16} height={p.size||16} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg>,
  Download: (p) => <svg viewBox="0 0 24 24" width={p.size||16} height={p.size||16} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg>,
  Shield: (p) => <svg viewBox="0 0 24 24" width={p.size||18} height={p.size||18} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  X: (p) => <svg viewBox="0 0 24 24" width={p.size||18} height={p.size||18} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>,
  Sun: (p) => <svg viewBox="0 0 24 24" width={p.size||18} height={p.size||18} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>,
  Moon: (p) => <svg viewBox="0 0 24 24" width={p.size||18} height={p.size||18} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
  Home: (p) => <svg viewBox="0 0 24 24" width={p.size||22} height={p.size||22} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="m3 11 9-8 9 8M5 10v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10"/></svg>,
  Bat: (p) => <svg viewBox="0 0 24 24" width={p.size||22} height={p.size||22} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M14 4l6 6-9 9-3 3-3-3 3-3 9-9z"/><circle cx="5" cy="19" r="2"/></svg>,
  Mound: (p) => <svg viewBox="0 0 24 24" width={p.size||22} height={p.size||22} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 9c1.5 1 2.5 2.5 4 2.5S14.5 10 16 9M8 15c1.5-1 2.5-2.5 4-2.5s2.5 1.5 4 2.5"/></svg>,
  Glove: (p) => <svg viewBox="0 0 24 24" width={p.size||22} height={p.size||22} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12V6a3 3 0 0 1 6 0v3M11 9V5a2 2 0 0 1 4 0v5M15 10V7a2 2 0 0 1 4 0v8a6 6 0 0 1-6 6H9a4 4 0 0 1-4-4v-2"/></svg>,
  List: (p) => <svg viewBox="0 0 24 24" width={p.size||22} height={p.size||22} fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>,
};

export function BrandMark() {
  return (
    <span className="brand-mark">
      <span className="brand-logo" aria-hidden="true">
        <svg viewBox="0 0 32 32" width="22" height="22">
          <path d="M 16 28.5 L 3 12 A 16 16 0 0 1 29 12 Z" fill="var(--good-tint)" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
          <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" fill="none" opacity="0.55">
            <line x1="16" y1="8"  x2="23" y2="16"/>
            <line x1="23" y1="16" x2="16" y2="24"/>
            <line x1="16" y1="24" x2="9"  y2="16"/>
            <line x1="9"  y1="16" x2="16" y2="8"/>
            <line x1="16" y1="8"  x2="16" y2="24"/>
            <line x1="9"  y1="16" x2="23" y2="16"/>
          </g>
          <circle cx="16" cy="8"  r="2.2" fill="currentColor"/>
          <circle cx="23" cy="16" r="1.9" fill="currentColor"/>
          <circle cx="16" cy="24" r="1.9" fill="currentColor"/>
          <circle cx="9"  cy="16" r="1.9" fill="currentColor"/>
          <circle cx="16" cy="16" r="2.6" fill="var(--red)" stroke="currentColor" strokeWidth="1"/>
        </svg>
      </span>
      <span className="brand-word">Scouting Nexus</span>
    </span>
  );
}

export function TopBar({ left, right, theme, onToggleTheme }) {
  return (
    <header className="appbar">
      <div className="appbar-left">{left}</div>
      <div className="appbar-right">
        {right}
        <button className="icon-btn" aria-label="Toggle theme" onClick={onToggleTheme}>
          {theme === 'dark' ? <I.Sun /> : <I.Moon />}
        </button>
      </div>
    </header>
  );
}

export const fmt = {
  avg: (v) => v == null ? '—' : Number(v).toFixed(3).replace(/^0\./, '.'),
  dec: (v, d=2) => v == null ? '—' : Number(v).toFixed(d),
  pct: (v) => v == null ? '—' : Number(v).toFixed(1) + '%',
  ip: (v) => {
    if (v == null) return '—';
    const num = Number(v); if (!Number.isFinite(num)) return String(v);
    const int = Math.trunc(num), frac = Math.abs(num - int);
    if (Math.abs(frac - 0.1) < 0.02) return `${int}.1`;
    if (Math.abs(frac - 0.2) < 0.02) return `${int}.2`;
    let outs = Math.round(frac * 3), innings = int;
    if (outs >= 3) { innings++; outs = 0; }
    return outs === 0 ? String(innings) : `${innings}.${outs}`;
  },
  cell: (v, kind) => {
    if (v == null || v === '' || (typeof v === 'number' && !Number.isFinite(v))) return '—';
    if (kind === 'avg')  return fmt.avg(v);
    if (kind === 'dec2') return fmt.dec(v, 2);
    if (kind === 'dec3') return fmt.dec(v, 3);
    if (kind === 'pct1') return fmt.pct(v);
    if (kind === 'ip')   return fmt.ip(v);
    return v;
  }
};

export function Sparkline({ data, w = 80, h = 24 }) {
  if (!data || data.length < 2) return <span className="mono" style={{color:'var(--text-3)'}}>—</span>;
  const min = Math.min(...data), max = Math.max(...data);
  const range = (max - min) || 1;
  const stepX = w / (data.length - 1);
  const pts = data.map((v, i) => [i * stepX, h - ((v - min) / range) * (h - 4) - 2]);
  const path = pts.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ');
  const area = `${path} L${w} ${h} L0 ${h} Z`;
  const last = pts[pts.length - 1];
  return (
    <svg className="sparkline" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none">
      <path d={area} className="spark-area"/>
      <path d={path} className="spark-line"/>
      <circle cx={last[0]} cy={last[1]} r={2} className="spark-pt"/>
    </svg>
  );
}

export function ErrorsDiamond({ errors }) {
  const HX = 100, HY = 178, R = 162, baseR = 56;
  const A_LF = -135, A_RF = -45;
  const rad = a => (a * Math.PI) / 180;
  const pt  = (a, r) => [HX + r * Math.cos(rad(a)), HY + r * Math.sin(rad(a))];
  const [lfx,lfy] = pt(A_LF,R), [rfx,rfy] = pt(A_RF,R);
  const fieldPath = `M ${HX} ${HY} L ${lfx} ${lfy} A ${R} ${R} 0 0 1 ${rfx} ${rfy} Z`;
  const [b1x,b1y]=pt(-45,baseR), [b2x,b2y]=pt(-90,baseR*Math.SQRT2), [b3x,b3y]=pt(-135,baseR);
  const [pmx,pmy]=pt(-90,baseR*0.7);
  const POSITIONS = [
    {k:'C',  label:'C',  x:HX,                    y:HY-12},
    {k:'P',  label:'P',  x:pt(-90, baseR*0.7)[0],  y:pt(-90, baseR*0.7)[1]},
    {k:'1B', label:'1B', x:pt(-55, baseR*1.2)[0],  y:pt(-55, baseR*1.2)[1]},
    {k:'3B', label:'3B', x:pt(-125,baseR*1.2)[0],  y:pt(-125,baseR*1.2)[1]},
    {k:'2B', label:'2B', x:pt(-72, baseR*1.65)[0], y:pt(-72, baseR*1.65)[1]},
    {k:'SS', label:'SS', x:pt(-108,baseR*1.65)[0], y:pt(-108,baseR*1.65)[1]},
    {k:'LF', label:'LF', x:pt(-122,R*0.82)[0],     y:pt(-122,R*0.82)[1]},
    {k:'CF', label:'CF', x:pt(-90, R*0.86)[0],     y:pt(-90, R*0.86)[1]},
    {k:'RF', label:'RF', x:pt(-58, R*0.82)[0],     y:pt(-58, R*0.82)[1]},
  ];
  const max = Math.max(1, ...Object.values(errors||{}));
  return (
    <svg viewBox="0 0 200 200" className="diamond" aria-label="Team defense">
      <path d={fieldPath} fill="var(--good-tint)" stroke="var(--border-strong)" strokeWidth="1"/>
      <line x1={HX} y1={HY} x2={lfx} y2={lfy} stroke="var(--border-strong)" strokeWidth="1"/>
      <line x1={HX} y1={HY} x2={rfx} y2={rfy} stroke="var(--border-strong)" strokeWidth="1"/>
      <polygon points={`${HX},${HY} ${b1x},${b1y} ${b2x},${b2y} ${b3x},${b3y}`} fill="rgba(202,168,124,0.32)" stroke="var(--border-strong)" strokeWidth="1"/>
      <circle cx={pmx} cy={pmy} r="3" fill="rgba(202,168,124,0.6)" stroke="var(--border-strong)" strokeWidth="0.5"/>
      {[[b1x,b1y],[b2x,b2y],[b3x,b3y]].map(([x,y],i)=>(
        <rect key={i} x={x-2.2} y={y-2.2} width={4.4} height={4.4} fill="var(--surface)" stroke="var(--text-3)" strokeWidth="0.7" transform={`rotate(45 ${x} ${y})`}/>
      ))}
      <polygon points={`${HX-3},${HY-1} ${HX+3},${HY-1} ${HX+3},${HY+1.5} ${HX},${HY+3.5} ${HX-3},${HY+1.5}`} fill="var(--surface)" stroke="var(--text-3)" strokeWidth="0.7"/>
      {POSITIONS.map(p=>{
        const e=(errors&&errors[p.k])||0;
        const r=11+(e/max)*6;
        const fill=e===0?'rgba(80,90,110,0.14)':`rgba(230,57,70,${0.25+(e/max)*0.55})`;
        const stroke=e===0?'var(--border-strong)':'var(--red)';
        const countColor=e===0?'var(--text-3)':'var(--text)';
        return (
          <g key={p.k}>
            <circle cx={p.x} cy={p.y} r={r} fill={fill} stroke={stroke} strokeWidth={e?1.8:1}/>
            <text x={p.x} y={p.y-4} textAnchor="middle" dominantBaseline="middle" style={{fontFamily:'var(--font-display)',fontWeight:700,fontSize:10,fill:'var(--text)'}}>{p.label}</text>
            <text x={p.x} y={p.y+7.5} textAnchor="middle" dominantBaseline="middle" style={{fontFamily:'var(--font-mono)',fontSize:11,fill:countColor,fontWeight:800}}>{e}</text>
          </g>
        );
      })}
    </svg>
  );
}

export function SprayDiamond({ left, center, right }) {
  const total=(left||0)+(center||0)+(right||0)||1;
  const lf=left/total, cf=center/total, rf=right/total;
  const HX=100,HY=175,R=155,A_LF=-135,A_RF=-45;
  const A1=A_LF,A2=A_LF+30,A3=A_LF+60,A4=A_RF;
  const rad=a=>(a*Math.PI)/180;
  const pt=(a,r=R)=>[HX+r*Math.cos(rad(a)),HY+r*Math.sin(rad(a))];
  const [lfx,lfy]=pt(A_LF),[rfx,rfy]=pt(A_RF);
  const fieldPath=`M ${HX} ${HY} L ${lfx} ${lfy} A ${R} ${R} 0 0 1 ${rfx} ${rfy} Z`;
  const slice=(a1,a2)=>{const[x1,y1]=pt(a1),[x2,y2]=pt(a2);return `M ${HX} ${HY} L ${x1} ${y1} A ${R} ${R} 0 0 1 ${x2} ${y2} Z`;};
  const baseR=38;
  const [b1x,b1y]=pt(-45,baseR),[b2x,b2y]=pt(-90,baseR*Math.SQRT2),[b3x,b3y]=pt(-135,baseR);
  const [pmx,pmy]=pt(-90,baseR*0.95);
  const [llx,lly]=pt((A1+A2)/2,R*0.62),[clx,cly]=pt((A2+A3)/2,R*0.62),[rlx,rly]=pt((A3+A4)/2,R*0.62);
  return (
    <svg viewBox="0 0 200 200" className="diamond" aria-label="Spray chart">
      <defs><clipPath id="field-clip"><path d={fieldPath}/></clipPath></defs>
      <path d={fieldPath} fill="var(--good-tint)" stroke="var(--border-strong)" strokeWidth="1"/>
      <g clipPath="url(#field-clip)">
        <path d={slice(A1,A2)} fill="var(--red)"      opacity={0.18+lf*0.6} stroke="var(--red)"      strokeOpacity="0.45" strokeWidth="0.8"/>
        <path d={slice(A2,A3)} fill="var(--navy-700)" opacity={0.18+cf*0.6} stroke="var(--navy-700)" strokeOpacity="0.45" strokeWidth="0.8"/>
        <path d={slice(A3,A4)} fill="var(--good)"     opacity={0.18+rf*0.6} stroke="var(--good)"     strokeOpacity="0.45" strokeWidth="0.8"/>
      </g>
      <line x1={HX} y1={HY} x2={lfx} y2={lfy} stroke="var(--border-strong)" strokeWidth="1"/>
      <line x1={HX} y1={HY} x2={rfx} y2={rfy} stroke="var(--border-strong)" strokeWidth="1"/>
      <polygon points={`${HX},${HY} ${b1x},${b1y} ${b2x},${b2y} ${b3x},${b3y}`} fill="rgba(202,168,124,0.35)" stroke="var(--border-strong)" strokeWidth="1"/>
      <circle cx={pmx} cy={pmy} r="3" fill="rgba(202,168,124,0.6)" stroke="var(--border-strong)" strokeWidth="0.6"/>
      {[[b1x,b1y],[b2x,b2y],[b3x,b3y]].map(([x,y],i)=>(
        <rect key={i} x={x-2.5} y={y-2.5} width={5} height={5} fill="var(--surface)" stroke="var(--text-3)" strokeWidth="0.8" transform={`rotate(45 ${x} ${y})`}/>
      ))}
      <polygon points={`${HX-3.5},${HY-1} ${HX+3.5},${HY-1} ${HX+3.5},${HY+1.5} ${HX},${HY+4} ${HX-3.5},${HY+1.5}`} fill="var(--surface)" stroke="var(--text-3)" strokeWidth="0.8"/>
      <text x={llx} y={lly} textAnchor="middle" style={{fontFamily:'var(--font-display)',fontWeight:700,fill:'var(--text)'}}>
        <tspan x={llx} dy="-0.4em" style={{fontSize:9,letterSpacing:'0.04em'}}>Left</tspan>
        <tspan x={llx} dy="1.25em" style={{fontSize:11}}>{(lf*100).toFixed(0)}%</tspan>
      </text>
      <text x={clx} y={cly} textAnchor="middle" style={{fontFamily:'var(--font-display)',fontWeight:700,fill:'var(--text)'}}>
        <tspan x={clx} dy="-0.4em" style={{fontSize:9,letterSpacing:'0.04em'}}>Center</tspan>
        <tspan x={clx} dy="1.25em" style={{fontSize:11}}>{(cf*100).toFixed(0)}%</tspan>
      </text>
      <text x={rlx} y={rly} textAnchor="middle" style={{fontFamily:'var(--font-display)',fontWeight:700,fill:'var(--text)'}}>
        <tspan x={rlx} dy="-0.4em" style={{fontSize:9,letterSpacing:'0.04em'}}>Right</tspan>
        <tspan x={rlx} dy="1.25em" style={{fontSize:11}}>{(rf*100).toFixed(0)}%</tspan>
      </text>
    </svg>
  );
}
